import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UINextStep  from '../subcomponents/UINextStep';
import UIPreviousStep  from '../subcomponents/UIPreviousStep';
import UIVoice  from '../subcomponents/UIVoice';
import UIHeaders  from '../subcomponents/UIHeaders';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TTitle(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.PREVIOUS_STEP]:{ ...UIPreviousStep({ ...props }) },
			[subComponentTypes.HEADERS]:{ ...UIHeaders({ ...props, size:7 }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		// console.log(rawProperties);
		let flatProperties = [
			{
				type: 'group',
				key: 'headers group',
				title: rawProperties.Headers.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.Headers.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.Headers.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.Headers.props.properties['anchor'],
						key: 'anchor',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Anchor',
					},
					{
						...rawProperties.Headers.props.properties['alignment'],
						key: 'alignment',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Alignment',
					},
					{
						...rawProperties.Headers.props.properties['header spacing'],
						key: 'header spacing',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Spacing',
					},
				].concat((()=>
				{
					let generatedHeaders = [];
					let headerCounter = 1;
					while(rawProperties.Headers.props.properties[`header ${headerCounter} text`])
					{
						generatedHeaders.push({
							type: 'group',
							key: `header ${headerCounter} group`,
							collapsed: true,
							title: `Header ${headerCounter}`,
							titleAddon: {
								key: `header ${headerCounter} text`,
								subcomponent: rawProperties.Headers.props.subcomponent
							},
							subcomponent: null,
							decorator: {
								...rawProperties.Headers.props.properties[`header ${headerCounter} visible`],
								key: `header ${headerCounter} visible`,
								type: 'toggle-icon',
								subcomponent: rawProperties.Headers.props.subcomponent,
								title: '',
							},
							children: [
								{
									...rawProperties.Headers.props.properties[`header ${headerCounter} text`],
									key: `header ${headerCounter} text`,
									subcomponent: rawProperties.Headers.props.subcomponent,
									title: "",
								},
								{
									type: 'color-alpha',
									title: "Text",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} text color`],
										key: `header ${headerCounter} text color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} text alpha`],
										key: `header ${headerCounter} text alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Background",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} background color`],
										key: `header ${headerCounter} background color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} background alpha`],
										key: `header ${headerCounter} background alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Stroke",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} shadow color`],
										key: `header ${headerCounter} shadow color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} shadow alpha`],
										key: `header ${headerCounter} shadow alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									...rawProperties.Headers.props.properties[`header ${headerCounter} link`],
									key: `header ${headerCounter} link`,
									subcomponent: rawProperties.Headers.props.subcomponent,
									title: "Target",
								},
							]
						})
						headerCounter++;
					}
					return generatedHeaders;
				})())
			},
			{
				...rawProperties.NextStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.NextStep.props.subcomponent,
				title: rawProperties.NextStep.props.title,
			},
			{
				...rawProperties.PreviousStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.PreviousStep.props.subcomponent,
				title: rawProperties.PreviousStep.props.title,
			},
			{
				type: 'group',
				key: 'voice group',
				tooltip: TooltipKeys.UIVoice,
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]

                
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}

	return (
		props.context === 'editor' ? 
			<>
				{repackProperties()}
			</>
			:
			<>
				<UINextStep {...props} />
				<UIPreviousStep {...props} />
				<UIHeaders {...props} size={7} />
				<UIVoice {...props} />
			</>
	);
}